"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../constants");
var _hooks = require("../../../helpers/hooks");
var _Button = _interopRequireDefault(require("../../Button/Button"));
var _Svg = _interopRequireDefault(require("../../Svg/Svg"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var BorderedType = function BorderedType(_ref) {
  var icon = _ref.icon,
    children = _ref.children,
    title = _ref.title,
    isActive = _ref.isActive,
    setActiveChild = _ref.setActiveChild,
    id = _ref.id,
    subtitle = _ref.subtitle;
  var _useState = (0, _react.useState)(isActive),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var wrapperRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (setActiveChild) {
      setIsOpen(isActive);
    }
  }, [isActive]);
  if (!setActiveChild) {
    (0, _hooks.useOutsideClick)(wrapperRef, function () {
      setIsOpen(false);
    });
  }
  var onClick = function onClick() {
    if (setActiveChild) {
      setActiveChild(id);
      if (isOpen) setActiveChild(null);
    } else {
      setIsOpen(!isOpen);
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: wrapperRef,
    className: "padding-x-sm padding-y-md d8-u-radius-md border width-100% margin-top-sm d8-u-hover-shadow-md"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    buttonType: _constants.BUTTON_TYPES.NO_STYLE,
    fullWidth: true,
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between items-center width-100%"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-left text-component width-100%"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "d8-u-font-size-base d8-u-font-weight-500"
  }, title), !!subtitle && /*#__PURE__*/_react["default"].createElement("p", {
    className: "d8-u-color-contrast-medium text-sm"
  }, subtitle)), /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: icon !== null && icon !== void 0 ? icon : "arrow-".concat(isOpen ? 'down' : 'right'),
    className: !!icon && 'icon--md',
    fill: _constants.COLORS.BLACK
  }))), isOpen && /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-lg"
  }, children));
};
BorderedType.propTypes = {
  icon: _propTypes["default"].string,
  title: _propTypes["default"].string.isRequired,
  subtitle: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].func]).isRequired,
  isActive: _propTypes["default"].bool,
  setActiveChild: _propTypes["default"].func,
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
var _default = exports["default"] = BorderedType;